// extracted by mini-css-extract-plugin
export default {"warning":"billingHistory_warning__2-cfh","container":"billingHistory_container__d4xJf"};